import axios from "axios";
import API from "../api";
import { createFilters } from "../utils/module-helper";
import Vue from "vue";

export const ModifiersModule = {
  state: {
    modifiers: [],
    modifierTags: [],
    isRequestingModifiers: false,
    errored: false,
    error: ""
  },
  actions: {
    getTaxes({ dispatch }) {
      // return dispatch('getModifiers', {category_id: 1}) //Need to get category 1 and 2
      return dispatch('getModifiers')
    },
    getModifiers({ commit }, modifierData) {
      commit("getModifiersRequest");
      let filterString = '';
      if (modifierData) {
        filterString = createFilters(modifierData);
      }
      return axios
        .get(`${API.BASE_URL}${API.TABS}${API.MODIFIERS}?${filterString}`, API.RequestHeaders())
        .then(response => {
          if (response.status === 200) {
            commit("getModifiersSuccess", response.data);
            return response.data.original
          }
        })
        .catch(error => {
          commit("getModifiersError", error);
        });
    },
    createModifier({ commit }, modifierData) {
      commit("createModifiersRequest");
      return axios
        .post(`${API.BASE_URL}${API.TABS}${API.MODIFIERS}`, modifierData, API.RequestHeaders())
        .then(response => {
          if (response.status === 201) {
            commit("createModifiersSuccess", response.data.original);
            return response.data.original
          }
        })
        .catch(error => {
          commit("createModifiersError", error);
        });
    },
    deleteModifier({ commit }, modifierId) {
      commit("deleteModifierRequest");
      return axios
        .delete(`${API.BASE_URL}${API.TABS}${API.MODIFIERS}/${modifierId}`, API.RequestHeaders())
        .then(response => {
          if (response.status === 200) {
            commit("deleteModifierSuccess", modifierId);
            return response.data.original
          }
        })
        .catch(error => {
          commit("deleteModifierError", error);
        });
    },
    updateModifier({ commit }, modifierData) {
      const modifierId = modifierData.id;
      delete modifierData.id;

      commit("updateModifiersRequest");
      return axios
        .put(`${API.BASE_URL}${API.TABS}${API.MODIFIERS}/${modifierId}`, modifierData, API.RequestHeaders())
        .then(response => {
          if (response.status === 200) {
            commit("updateModifiersSuccess", response.data.original);
            return response.data.original
          }
        })
        .catch(error => {
          commit("updateModifiersError", error);
        });
    },
    getModifierTags({
      commit
    }) {
      return new Promise(async (resolve, reject) => {
        commit("getModifierTagsRequest");
        return axios
          .get(`${API.BASE_URL}${API.MODIFIER_TAGS}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("getModifierTagsSuccess", response.data);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("getModifierTagError", error);
            reject(error);
          });
      });
    },
    createModifierTag({
      commit
    }, record) {
      return new Promise(async (resolve, reject) => {
        commit("createModifierTagRequest");
        return axios
          .post(`${API.BASE_URL}${API.MODIFIER_TAGS}`, record, API.RequestHeaders())
          .then(response => {
            if (response.status === 201) {
              commit("createModifierTagSuccess", response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("modifierTagError", error);
            reject(error);
          });
      });
    },
    deleteModifierTag({
      commit
    }, recordId) {
      return new Promise(async (resolve, reject) => {
        commit("deleteModifierTagRequest");
        return axios
          .delete(`${API.BASE_URL}${API.MODIFIER_TAGS}/${recordId}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("deleteModifierTagSuccess", recordId);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("deleteModifierTagError", error);
            reject(error);
          });
      });
    },
    deleteModifierAndModifierTags({
      dispatch, state
    }, modifierId) {
      const modifier = state.modifiers.find(modifier => modifier.id === modifierId);

      return new Promise(async (resolve, reject) => {
        try {
          Promise
            .all(modifier.modifier_tag.map(modTag => {
              return dispatch("deleteModifierTag", modTag.id)
            }))
            .then(() => {
              dispatch('deleteModifier', modifier.id).then(() => {
                resolve(modifier)
              })
            })
            .catch(e => {
              reject(e);
            })
        } catch (e) {
          reject('Was unable to find valid delete-able tax.')
        }
      });
    }
  },
  mutations: {
    getModifiersRequest(state) {
      state.isRequestingModifiers = true;
    },
    getModifiersSuccess(state, payload) {
      state.modifiers = payload;
      state.isRequestingModifiers = false;
    },
    getModifiersError(state, error) {
      state.isRequestingModifiers = false;
      state.errored = true;
      state.error = error.message;
    },
    createModifiersRequest(state) {
      state.isRequestingModifiers = true;
    },
    createModifiersSuccess(state, payload) {
      payload.modifier_tag = []; //TODO - This should come in from the backend
      state.modifiers.push(payload);
      state.isRequestingModifiers = false;
    },
    createModifiersError(state, error) {
      state.isRequestingModifiers = false;
      state.errored = true;
      state.error = error.message;
    },
    updateModifiersRequest(state) {
      state.isRequestingModifiers = true;
    },
    updateModifiersSuccess(state, payload) {
      const modifierIndex = state.modifiers.map(modifier => modifier.id).indexOf(payload.id);
      Vue.set(state.modifiers, modifierIndex, {...state.modifiers[modifierIndex], ...payload})
      state.isRequestingModifiers = false;
    },
    updateModifiersError(state, error) {
      state.isRequestingModifiers = false;
      state.errored = true;
      state.error = error.message;
    },
    getModifierTagsRequest(state) {
      state.isRequesting = true;
    },
    getModifierTagsSuccess(state, payload) {
      state.modifierTags = payload;
      state.isRequesting = false;
    },
    createModifierTagRequest(state) {
      state.isRequesting = true;
    },
    createModifierTagSuccess(state, payload) {
      const affectedModifier = state.modifiers.find(modifier => modifier.id === payload.modifier_id)

      if (!affectedModifier.modifier_tag) {
        affectedModifier.modifier_tag = [];
      }

      affectedModifier.modifier_tag.push(payload)

      state.isRequesting = false;
    },
    modifierTagError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    deleteModifierRequest(state) {
      state.isRequesting = false;
    },
    deleteModifierSuccess(state, modifierId) {
      // find the removed object
      const removedObject = state.modifiers.find(
        modifier => modifier.id === modifierId
      );

      // find the index of the remove object in contacts array
      const removedObjectIndex = state.modifiers.indexOf(removedObject);

      // remove the object from state
      state.modifiers.splice(removedObjectIndex, 1);

      state.isRequesting = false;
    },
    deleteModifierTagRequest(state) {
      state.isRequesting = false;
    },
    deleteModifierTagSuccess(state, modifierTagId) {
      //find the modifier with this tag in it
      const affectedModifier = state.modifiers
        .find(modifier => modifier.modifier_tag
          .find(modTag => modTag.id === modifierTagId))

      //give it no quarter.
      _.remove(affectedModifier.modifier_tag,
        mod_tag => mod_tag.id === modifierTagId
      )

      state.isRequesting = false;
    },
    deleteModifierTagError(state) {
      state.isRequestingModifiers = false;
      state.errored = true;
      state.error = error.message;
    }
  },
  getters: {
    getAvailableModifiers(state) {
      return state.modifiers;
    },
    getAvailableAdjustments(state) {
      return state.modifiers
        .filter(modifier => (
          Object.values(ADJUSTMENT_TYPES).indexOf(modifier.category_id) !== -1
        ))
    }
  }
};
